module.exports = {
	"base": {
		"welcome": "Willkommen bei Mulligans, %{name}!",
		"user": "Benutzerinfo",
		"devices": "Geräte",
		"refunds": "Rückerstattung",
		"resources": "Ressourcen",
		"transactions": "Bestellungen und Rücksendungen",
		"email": "E-Mail",
		"password": "Kennwort",
		"save": "Speichern",
		"sign-out": "Abmelden",
		"cancel": "Abbrechen",
		"close": "Schließen",
		"learn-more": "Erfahren Sie mehr",
		"required": "Erforderlich",
		"support": "Support",
		"bookshelf": "Bücherregal",
		"launch": "Starten",
		"download": "Download",
		"details": "Details",
		"cannot-be-blank": "%{field} darf nicht leer sein.",
		"saving": "Speichern…",
		"done": "Fertig",
		"failed": "Fehlgeschlagen",
		"copy": "Kopieren"
	},
	"signin": {
		"login-failure": "E-Mail oder Passwort ist falsch",
		"welcome-large": "Willkommen beim <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Anmelden",
		"forgot-password": "Passwort vergessen?",
		"new-to-vst": "Neu bei %{brand}?",
		"create-account": "Ein Konto erstellen",
		"signing-in": "Anmelden...",
		"signin-failed": "Anmelden fehlgeschlagen"
	},
	"transactions": {
		"price": "Preis",
		"excluded": "(Ohne MwSt.)",
		"quantity": "Menge",
		"confirmation#": "Bestätigung #",
		"payment": "Zahlung",
		"purchased": "Gekauft",
		"purchase-details": "Einkaufsdetails",
		"subtotal": "Zwischensumme",
		"total": "Gesamt",
		"tax": "Steuern",
		"loading": "Hallo Käufer, wir laden Ihre Transaktionen...",
		"no-purchases": "Sie haben keine Käufe.",
		"seller-vat": "MwSt. Verkäufer",
		"total-vat": "Gezahlte %{vat} insgesamt",
		"portion": "%{subTax} MwSt. %{rate}%",
		"vat-disclosure": "Preis beinhaltet %{vat}",
		"purchases": "Käufe",
		"refunded-items": "Rückerstattete Artikel",
		"book-title": "Buchtitel",
		"refund-details": "Details zur Rückerstattung",
		"print-receipt": "Beleg ausdrucken",
		"request-refund": "Rückerstattung anfordern",
		"expired": "Abgelaufen",
		"expires-in": "Läuft ab: %{date}",
		"details-refund": "Details & Rückerstattung",
		"modal": {
			"cant-refund-title": "Rückerstattung nicht verfügbar",
			"cant-refund": "Ihr Buch kann aus einem oder mehreren der folgenden Gründe nicht rückerstattet werden.",
			"cant-refund-1": "Ein zu großer Teil des Buchs wurde angesehen.",
			"cant-refund-2": "Seit dem Kaufdatum sind mehr als 14 Tage verstrichen.",
			"cant-refund-3": "Ihr Online-Ressourcen-Code wurde angezeigt.",
			"cant-refund-4": "Das Buch wurde bereits rückerstattet.",
			"cant-refund-5": "Alle Codes wurden bereits eingelöst und/oder rückerstattet.",
			"cant-refund-6": "Seit dem Kaufdatum sind mehr als 30 Tage verstrichen.",
			"cant-refund-support": "Wenn Sie noch Fragen zu den Rückerstattungsbestimmungen von %{brand} haben, kontaktieren Sie den <a href='%{support_url}' target='_blank'>Support</a>."
		},
		"license": {
			"perpetual": "Der Online-Zugang läuft nicht ab",
			"days": "%{days}-tägiger Zugang"
		}
	},
	"devices": {
		"description": "%{brand} erlaubt Ihnen, <span>%{desktop}</span> Computer und <span>%{mobile}</span> Mobilgeräte/Tablets jederzeit aktiviert zu haben.",
		"loading": "Hi, wir rufen Ihre Geräte ab :)",
		"no-active": "Sie haben keine aktiven Geräte.",
		"deactivate": "Deaktivieren"
	},
	"user": {
		"personal-information": "Persönliche Informationen",
		"security-information": "Sicherheitsinformationen",
		"notifications": "Benachrichtigungen",
		"first-name": "Vorname",
		"last-name": "Nachname",
		"change-password-title": "Kennwort ändern",
		"current-password": "Aktuelles Passwort",
		"new-password": "Neues Kennwort",
		"security-password": "Kennwort",
		"confirm-new-password": "Neues Kennwort bestätigen",
		"security-question": "Sicherheitsfrage",
		"security-info-change": "Ändern",
		"question": "Frage",
		"answer": "Antwort",
		"notifications-text": "Senden Sie mir gelegentlich Updates zu meiner Kontoaktivität, Produkt-Updates und Sonderangeboten zu.",
		"loading": "Rex ist auf der Suche nach Ihren Benutzerinformationen, eine Sekunde 🐶",
		"change-password-text": "Passwörter müssen mind. 8 Zeichen und davon mind. einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen enthalten.",
		"email-locked": "E-Mail gesperrt",
		"email-locked-description": "Sie haben keinen Zugang zum Ändern Ihrer E-Mail.",
		"email-locked-more": "Bitte kontaktieren Sie Ihren Administrator.",
		"security-question6": "Welcher ist Ihr Lieblingssport?",
		"security-question7": "Welche Geschmacksrichtung hat Ihr Lieblingseis?",
		"security-question8": "Wie ist der Name Ihres Lieblingstiers?",
		"security-question9": "Als Sie jung waren, was wollten Sie als Erwachsener werden?",
		"security-question10": "Wie ist der Nachname Ihres Lieblingslehrers?",
		"new-password-failure": "Das Passwort erfüllt die Anforderungen nicht",
		"confirm-password-failure": "Das Passwort muss übereinstimmen",
		"new-password-tooltip": "Das Passwort muss mind. 8 Zeichen und davon mind. einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen enthalten.",
		"enter-valid-email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
		"password-cannot-be-same": "Das Passwort darf nicht das gleiche wie das vorherige Passwort sein",
		"incorrect-password": "Falsches Passwort",
		"complete-account": "Anscheinend musst du <a href='%{href}'>dein Konto abschließen</a>.",
		"completing-allows": "Wenn du dein Konto abschließt, kannst du Bücher offline auf deinen Mobil-Apps lesen und Notizen mit Freunden teilen und markieren.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Zusätzliche Ressourcen",
		"access-codes": "Zugangscodes",
		"print-on-demand": "Print-on-Demand",
		"check-pod": "Druckoptionen des Verlags für Ihre Bücher prüfen.",
		"check-now": "Jetzt prüfen",
		"loading": "Bitte warten Sie, wir aktualisieren Ihre Ressourcen.",
		"in": "in",
		"access-code-intro": "Ein Zugangscode ist ein Passwort, das Sie verwenden, um auf Kursinhalte online zuzugreifen. Wenn Sie einen Code für einen Artikel angezeigt haben, können Sie diesen Artikel nicht mehr zurückgeben. Für weitere Informationen zur Verwendung Ihrer Zugangscodes, besuchen Sie den <a href='%{support_url}' target='_blank'>Support</a>.",
		"expires": "Läuft ab:",
		"expiration-message": "Enthält Anweisungen zur Verwendung Ihres Zugangscodes.",
		"copy-fail": "Kopieren nicht möglich. Bitte wählen Sie den Code aus und kopieren Sie ihn manuell.",
		"launch-site": "Site starten",
		"launch-book": "Buch starten",
		"reveal-code": "Code anzeigen",
		"no-resources": "Sie haben keine Ressourcen.",
		"no-access-codes": "Sie haben keine Zugangscodes.",
		"no-ancillaries": "Keine zusätzlichen Ressourcen für diesen Titel",
		"name": "Name",
		"type": "Typ",
		"size": "Größe",
		"download-all": "Alles herunterladen",
		"back": "Zurück zu Ressourcen"
	},
	"refunds": {
		"states": {
			"refunded": "Rückerstattet",
			"unavailable": "Rückerstattung nicht verfügbar"
		},
		"reasons": {
			"dropped": "Ich habe den Kurs gestrichen",
			"wrong": "Dies war das falsche Buch für meinen Kurs",
			"print": "Ich habe stattdessen die Druckversion gekauft",
			"missing": "Das Buch enthält nicht alles, was ich für meinen Kurs benötige (z.B. eine CD, Webzugang, Videos)",
			"other": "Sonstiges"
		},
		"bulk": {
			"policy": "Durch Klicken auf die Schaltfläche „Rückerstattung abschließen“ unten, stimme ich den Rückerstattungsbestimmungen von %{brand} <a href='%{policy_url}' target='_blank'>zu</a>.",
			"complete": "Rückerstattung abschließen",
			"view-details": "Details zur Rückerstattung ansehen",
			"success": "Deine Rückerstattung wurde angefordert. Bitte warte 48 Stunden auf die Verarbeitung.",
			"failure": "Huch! Etwas ist schiefgegangen! Leider ist Ihre Rückerstattung nicht abgeschlossen.",
			"retry": "Versuchen Sie es erneut",
			"support": "Support kontaktieren",
			"available-codes": "Erhältliche Codes",
			"codes-selected": "Ausgewählte Codes",
			"download": "Codes herunterladen",
			"partially-refunded": "Teilweise rückerstattet",
			"pick-one": "Sie müssen mindestens einen Code für eine Rückerstattung auswählen"
		},
		"refund": "Rückerstatten",
		"all": "Alles rückerstatten?",
		"missing-reason": "Sie müssen einen Grund auswählen, um fortzufahren",
		"missing-elaboration": "Bitte genauer angeben",
		"policy": "Wenn Sie auf die Schaltfläche „Anforderung der Rückerstattung abschließen“ unten klicken, stimmen Sie zu, dass Sie bei einem erneuten Kauf dieses %{brand} eTextbooks keine weiteren Rückerstattungen für das selbe eTextbook anfragen können. Die vollständigen Rückgaberichtlinien anzeigen.",
		"refunded": "Rückerstattet",
		"sorry": "Es tut uns leid, dass Sie mit Ihrem Kauf nicht zufrieden waren.",
		"error": "Etwas ist schiefgegangen",
		"error-explain": "Wir konnten Ihre Rückerstattung nicht verarbeiten. Versuchen Sie es bitte erneut.",
		"why": "Wir möchten wissen warum",
		"no-refunds": "Sie haben keine rückerstatteten Artikel.",
		"select-codes": "Wählen Sie Code (s) zur Rückerstattung:",
		"number": "Wie viele?",
		"back": "Zurück zu Rückerstattungen"
	},
	"purchases": {
		"back": "Zurück zu Käufen"
	},
	"global-bar": {
		"account": "Kontoeinstellungen"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/de.json
 ** module id = 974
 ** module chunks = 0
 **/